'use client';
import { useState } from 'react';
const EmailForm = ({ list_id }) => {
  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null }
  });

  const [inputs, setInputs] = useState({
    subscribe_email: ''
  });

  const handleResponse = (status, msg) => {
    if (status === 201 || status === 200) {
      setStatus({
        submitted: true,
        submitting: false,
        info: { error: false, msg: msg }
      });
      setInputs({
        subscribe_email: ''
      });
    } else {
      setStatus({
        info: { error: true, msg: msg }
      });
    }
  };

  const handleOnChange = (e) => {
    e.persist();
    setInputs((prev) => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
    setStatus({
      submitted: false,
      submitting: false,
      info: { error: false, msg: null }
    });
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setStatus((prevStatus) => ({ ...prevStatus, submitting: true }));

    const $list = list_id;
    const $email = inputs.subscribe_email;

    if (!$email.match(/\S+@\S+/)) {
      handleResponse(
        400,
        `There's an issue with your provided email address.<br/> Please try again.`
      );
      return;
    }

    try {
      const res = await fetch('/api/emailSubscription', {
        body: JSON.stringify({
          email: $email,
          list: $list
        }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });

      if (!res.ok) {
        throw new Error('Network response was not ok');
      }

      await res.json();
      handleResponse(200, 'Thank you for signing up!');
    } catch (error) {
      console.error('Error during email subscription:', error);
      handleResponse(
        400,
        `There's an issue signing up for the newsletter. <br/> Please try again.`
      );
    }
  };

  return (
    <form
      onSubmit={handleOnSubmit}
      className="w-full max-w-full lg:max-w-[580px] lg:pt-2"
    >
      <div className="flex">
        <label htmlFor="subscribe_email" className="sr-only">
          Email address
        </label>
        <input
          id="subscribe_email"
          type="email"
          onChange={handleOnChange}
          value={inputs.subscribe_email}
          className="min-w-0 flex-auto border-0 bg-white px-3.5 py-2 text-gray-900 ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-inset sm:text-sm sm:leading-6"
          placeholder="Enter your email"
        />
        <button
          id="subscribe-email-submit"
          type="submit"
          disabled={status.submitting}
          className={`btn-secondary-dark h-11 appearance-none px-5 transition-shadow hover:shadow-md sm:px-4 lg:px-8`}
        >
          {!status.submitting
            ? !status.submitted
              ? 'Subscribe'
              : 'Subscribed'
            : 'Please wait'}
        </button>
      </div>
      {status.info.error && (
        <div
          className="text-error-red mt-4"
          dangerouslySetInnerHTML={{ __html: status.info.msg }}
        ></div>
      )}
    </form>
  );
};

export default EmailForm;
